import axios from "../utils/axios";

function request(functionId, body) {
  let data = {
    functionId,
    body
  };
  return axios.request({
    data: data,
    method: "post"
  });
}

// 写手端新增药品百科
export function newDrugEncyclopedia(body) {
  return request("health_cmp_biz_writerSaveDrugBaike", body);
}

// 修改药品百科
export function modifyDrugEncyclopedia(body) {
  return request("health_cmp_biz_writerUpdateDrugBaike", body);
}

// 运营端修改药品百科
export function manModifyDrugEncyclopedia(body) {
  return request("health_cmp_biz_manUpdateDrugBaike", body);
}

// 写手端查询药品库
export function queryDrugWarehouse(body) {
  return request("health_cmp_biz_WriterPageDrugInfoByParam", body);
}

// 运营端查询药品库
export function queryDrugWarehouseMan(body) {
  return request(" health_cmp_biz_manPageDrugInfoByParam", body);
}

// 运营端查询药品分类
export function queryDrugCategoryWithRel(body) {
  return request(" health_cmp_biz_queryDrugCategoryWithRel", body);
}
